<template>
  <a-modal
    title="新建飞机出入"
    :width="1080"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok', image) }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-form-item label="图片">
            <div class="clearfix" style="display: inline-block">
              <a-upload
                name="file"
                accept="image/png, image/jpeg, image/jpg"
                :action="actionUrl"
                list-type="picture-card"
                :file-list="fileList"
                :data="new_multipart_params"
                :before-upload="beforeUpload"
                @preview="handlePreview"
                @change="handleChange"
              >
                <div v-if="fileList.length < 1">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    图片上传
                  </div>
                </div>
              </a-upload>
              <span v-if="false">提示：图片宽高比为1:1</span>
              <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                <img alt="example" style="width: 100%" :src="previewImage" />
              </a-modal>
            </div>
          </a-form-item>
          <a-form-item label="飞机识别号">
            <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:64, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
          </a-form-item>
          <a-form-item label="出入状态">
            <a-select v-decorator="['status', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="请选择">
              <a-select-option :key="key" :value="key" v-for="(val, key) in this.$Dictionaries.monitor_plane_in_out_status">{{ val }}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="出入时间">
            <a-date-picker
              style="width:100%"
              v-decorator="['in_out_time', {rules: [{required: true, message: '必填项，请填写信息'}]}]"
              format="YYYY-MM-DD HH:mm:ss"
              show-time
              placeholder="请选择时间"
              @ok="inOutTimeOK"
            />
          </a-form-item>
          <a-form-item label="备注">
            <a-textarea v-decorator="['remark', {rules: [{required: false, message: '必填项，请填写信息'}, {max:128, message: '输入超出长度限制'}]}]" />
          </a-form-item>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment'
import { oss_token_list } from '@/api/oss_token'
// 表单字段
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      actionUrl: '',
      previewVisible: false,
      previewImage: '',
      image: undefined,
      new_multipart_params: {
        'key': '',
        'policy': '',
        'OSSAccessKeyId': '',
        'success_action_status': '200',
        'signature': ''
      },
      fileList: [],
      form: this.$form.createForm(this)
    }
  },
  created () {
    this.initOss()
  },
  methods: {
    moment,
    inOutTimeOK (value) {
      console.log(value.format('YYYY-MM-DD HH:mm:ss'))
    },
    initOss () {
      oss_token_list().then(({ data }) => {
        console.log(data, '我是返回值')
        this.new_multipart_params.OSSAccessKeyId = data.accessid
        this.new_multipart_params.policy = data.policy
        this.new_multipart_params.signature = data.signature
        this.actionUrl = 'https://static2.jnzbtz.com'
      })
    },
    getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    beforeUpload (file) {
      const name = file.name
      const suffix = name.substring(name.lastIndexOf('.') + 1)
      this.new_multipart_params.key = file.uid + '.' + suffix
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('你只能上传jpeg/png格式的图片')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('文件过大，请重新上传')
      }
      console.log('--------------------------------------', isJpgOrPng, isLt2M)
      return isJpgOrPng && isLt2M
    },
    // 进口图片
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj, () => {
        })
      }
      console.log('我要预览', file)
      this.previewImage = file.url || file.preview || file.thumbUrl
      this.previewVisible = true
    },
    handleChange ({ fileList, file }) {
      this.fileList = fileList
      if (file.status === 'removed') {
        this.form.setFieldsValue({ picture: '' })
        this.$message.error('请重新上传')
        this.image = undefined
      }
      if (file.status === 'done') {
        this.form.setFieldsValue({ picture: this.actionUrl + '/' + this.new_multipart_params.key })
        this.image = this.actionUrl + '/' + this.new_multipart_params.key
      }
    },
    handleCancel () {
      this.previewVisible = false
    }
  }
}
</script>
